// the css is injected automatically
require('!style-loader!css-loader!postcss-loader!stylus-loader!./iscompany.styl');

// this helps us remove everything exepct whats inside the body node
var strip = require("striphtml");
var checkbox = require("../checkbox/checkbox");

var getData = require('../../scripts/getdata')(MBGF.mbfa_apibase);
var validation = require('validation')(getData).iscompany;
var parsing = require('parsing').iscompany;

var dataSource = "";

function parse(text, next) {
    strip(require('raw!./iscompany.html'), function(outputHtml) {
        var match = parsing.parse(text);
        var options;

        if (match) {
            text = text.replace(match[0], outputHtml);
            next(text);
        }
        else {
            next(text);
        }
    });
};

function validate(context, err) {
    var value = get(context);
    var validationResult = !err ? validation.validate(value, false) : err;
    return validationResult.valid;
}

function get(context) {
    return checkbox.get(context);
}

function reset(context) {
    checkbox.reset(context);
}

module.exports = {
    parse: parse,

    validate: validate,
    get: get,
    dataSource: dataSource,
    reset: reset
};



// WEBPACK FOOTER //
// ./js-src/markdown-editor/modules/iscompany/iscompany.js